const getInterruptions = (rootState) => rootState.ws.interrupter.interruptions;

export default getInterruptions;
